<app-membership-pog-bar 
    *ngIf="offerSet.enable_membership_goal && mode == 'membership'" 
    [offerSet]="offerSet"></app-membership-pog-bar>

<app-contribution-pog-bar 
    *ngIf="offerSet.enable_contribution_goal && mode == 'contribution'" 
    [offerSet]="offerSet"></app-contribution-pog-bar>
